module.exports = __webpack_public_path__ + "static/media/driver.d30b920d.png";